export default () => {
  $('header.buttons-rs-panel button').on('click', function(){
    if ($(this).hasClass('bg-x-twitter')) {
      let url = 'https://twitter.com/intent/tweet?url=' + $(this).attr('data-href') + '&text=' + $(this).attr('data-title');
      let via = $(this).attr('data-via');
      if (via != ""
        && typeof via != "Undefined") {
        url += "&via=" + via;
      }
      window.open(url , '_blank');
    }

    if ($(this).hasClass('bg-facebook')) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + $(this).attr('data-href'), '_blank');
    }

    if ($(this).hasClass('bg-meneame')) {
      window.open('https://meneame.net/submit.php?url=' + $(this).attr('data-href'), '_blank');
    }
  });
}


